$(document).ready(function () {
  var origin = window.location.origin;
  var pathname = window.location.pathname;
  var debug = false;

  //récupére les paramètres d'urls
  function param(param) {
    var vars = {};
    window.location.href.replace(location.hash, "").replace(
      /[?&]+([^=&]+)=?([^&]*)?/gi, // regexp
      function (m, key, value) {
        // callback
        vars[key] = value !== undefined ? value : "";
      }
    );

    if (param) {
      return vars[param] ? vars[param] : null;
    }
    return vars;
  }

  debug = param("debug");

  //SUPPORT IE
  Modernizr.on("backgroundcliptext", function (result) {
    if (!result) {
      jQuery("main").addClass("ie");
    }
  });

  setTimeout(() => {
    jQuery("html")[0].scrollLeft = 0;
  }, 500);

  jQuery('a[href^="#"]').click(function () {
    var the_id = $(this).attr("href");
    if (the_id === "#") {
      return;
    }
    jQuery("html, body").animate(
      {
        scrollTop: $(the_id).offset().top,
      },
      "slow"
    );
    return false;
  });

  let icon = document.querySelector(".menu_icon");
  icon.addEventListener("click", () => {
    icon.classList.toggle("clicked");
  });

  // Contact Form Confirmation & Error
  if (jQuery(".contact")) {
    if ($("div").hasClass("gform_confirmation_wrapper")) {
      $(".contact .description").css({ display: "none" });
      $(".contact .requiText").css({ display: "none" });
    }

    if ($("div").hasClass("gform_validation_errors")) {
      $errorContainer = $(".gform_validation_errors");
      $(".special_form").append($errorContainer);
    }
  }

  // Cover Carousel
  const coverOwl = $("owl-cover-carousel");

  // carousel navigation
  var owl = $("#owl-carousel-article-text");
  function checkCarouselState(e) {
    const currentItem = e.item.index;
    const itemCount = e.item.count;
    const itemMax = e.relatedTarget.settings.items;

    if (currentItem === 0) {
      $(".owl-prev-article").addClass("disabled");
    } else {
      $(".owl-prev-article").removeClass("disabled");
    }

    if (currentItem >= itemCount - itemMax) {
      $(".owl-next-article").addClass("disabled");
    } else {
      $(".owl-next-article").removeClass("disabled");
    }
  }

  $(".owl-next-article").click(function (ev) {
    if (!ev.currentTarget.classList.contains("disabled"))
      owl.trigger("next.owl.carousel");
  });
  $(".owl-prev-article").click(function (ev) {
    if (!ev.currentTarget.classList.contains("disabled"))
      owl.trigger("prev.owl.carousel");
  });

  function setItemWidth(event) {
    let itemWidth = 318;
    let marginRight = 24;
    let totalItems = event.item.count + 1;
    let containerWidth = (itemWidth + marginRight) * totalItems;

    $("#owl-carousel-article-text .owl-item").width(itemWidth);
    $("#owl-carousel-article-text .owl-stage").css({
      width: containerWidth,
    });
  }

  function handleTranslationCoords(e) {
    let newCoordTargets = new Array(e.item.count)
      .fill(0)
      .map((_, i) => -(318 + 24) * (i + 1));

    e.relatedTarget._coordinates = newCoordTargets;
  }

  setTimeout(function () {
    coverOwl.owlCarousel({
      responsive: {
        0: {
          items: 1,
          margin: 0,
        },
        600: {
          items: 2,
          margin: 0,
        },
      },
    });
    owl.owlCarousel({
      onDragged: function (e) {
        checkCarouselState(e);
      },
      onInitialized: function (e) {
        handleTranslationCoords(e);

        checkCarouselState(e);
        setItemWidth(e);
      },
      onResized: function (e) {
        checkCarouselState(e);
        setItemWidth(e);
      },

      onTranslate: function (e) {
        checkCarouselState(e);
      },
      onTranslated: function (e) {
        checkCarouselState(e);
      },
      dots: false,
      responsive: {
        0: {
          items: 1,
          margin: 24,
        },
        600: {
          items: 2,
          margin: 24,
        },
        1460: {
          items: 3,
          margin: 24,
        },
      },
    });

    //carrousel article specific
    $(".carrousel.text .owl-carousel").owlCarousel({
      items: 3,
      loop: false,
      autoplay: false,
      nav: false,
      dots: false,
      responsive: {
        0: {
          items: 2,
        },
        1075: {
          items: 3,
          margin: 20,
        },
      },
    });

    $(".carrousel.big .owl-carousel").owlCarousel({
      items: 1,
      loop: true,
      autoplay: false,
      nav: false,
      dots: true,
    });

    $(".carousel-image .owl-carousel").owlCarousel({
      items: 1,
      loop: true,
      autoplay: false,
      nav: false,
      dots: true,
    });

    const owlItems = $(".owl-carousel .owl-stage .owl-item");
    for (let i = 0; i < owlItems.length; i++) {
      owlItems[i].style.zIndex = -i * 5;
    }
  }, 500);

  //categorie hover
  $(".remaining-categories").hover(function () {
    $(this).toggleClass("active");
  });
  $(".remaining-categories").on("touchstart", function (e) {
    e.preventDefault();
    $(this).toggleClass("active");
  });

  //size of image background for block text image
  if ($(window).width() > 767) {
    setTimeout(function () {
      $(".jsSize").each(function () {
        var $element = $(this).find(".size"); // Remplacez par votre sélecteur d'élément

        var fullHeight = $element.outerHeight(true);
        $(this).find(".content-image").css("height", fullHeight);
      });
    }, 500);
  }

  if ($(window).width() < 767) {
    setTimeout(function () {
      $(".cover .menu .owl-carousel").owlCarousel({
        items: 2,
        loop: false,
        autoplay: false,
        nav: false,
        dots: false,
        responsive: {
          0: {
            items: 1,
          },
        },
      });

      var firstBloc = jQuery("main section").first();
      if (!jQuery(firstBloc).hasClass("cover")) {
        jQuery("main").addClass("margeon");
      } else {
        jQuery("main").removeClass("margeon");
      }

      //logo on mobile remove margin on 2 last element
      var logoContainer = $(".logo-container");
      if (logoContainer.length > 0) {
        var logos = logoContainer.find(".logo");
        var logoCount = logos.length;
        if (logoCount >= 1) {
          if (logoCount % 2 === 1) {
            $(logos.last()).css("margin-bottom", "0px");
          } else {
            $(logos.slice(-2)).css("margin-bottom", "0px");
          }
        }
      }
    }, 500);
  }

  // filtre et masonry pour list article

  if (jQuery(".article-list .masonry")) {
    var searchQuery = "";

    // Listen to search field value
    $(".articles-search-btn").click(function () {
      searchQuery = $(".articles-search-field").val();
      filterAndUpdateUrl();
    });
    $(".articles-search-field").change(function () {
      searchQuery = $(".articles-search-field").val();
      filterAndUpdateUrl();
    });

    var $masonry = $(".masonry");
    $masonry.isotope({
      itemSelector: ".item",
      layoutMode: "masonry",
      masonry: {
        columnWidth: $masonry.width() / 3,
      },
    });

    $masonry.on("arrangeComplete", function (event, filteredItems) {
      if (filteredItems.length === 0) {
        jQuery(".masonry").find(".error-container").remove();
        var $errorMessage = $(
          '<div class="error-message"><h1>No insights found for the specified filter.</h1></div>'
        );
        var $errorContainer = $('<div class="error-container"></div>');
        $errorContainer.append($errorMessage);

        jQuery(".masonry").append($errorContainer);
      } else {
        jQuery(".masonry").find(".error-container").remove();
      }
    });

    var filterCategories = [];

    function filterAndUpdateUrl() {
      var filterString =
        filterCategories.length > 0 ? "." + filterCategories.join(", .") : "*";

      $masonry.isotope({
        filter: function () {
          var $this = $(this);
          var isSearchFound =
            $this.text().toLowerCase().includes(searchQuery.toLowerCase()) ||
            $this
              .find(".hidden-content")
              .text()
              .toLowerCase()
              .includes(searchQuery.toLowerCase());
          var searchResult = searchQuery ? isSearchFound : true;
          var filteredElems = filterString ? $this.is(filterString) : true;
          return searchResult && filteredElems;
        },
      });

      var url = new URL(window.location.href);
      url.searchParams.set("filter", filterCategories.join(","));
      window.history.pushState({ path: url.toString() }, "", url.toString());

      if (filterCategories.length === 0) {
        jQuery('.filter-article .btn[category="*"]').addClass("active");
      } else {
        jQuery('.filter-article .btn[category="*"]').removeClass("active");
      }
    }

    function selectCategories(e) {
      if (e && e.cancelable) e.preventDefault();

      var category = jQuery(this).attr("category");

      if (category === "*") {
        filterCategories = [];
        jQuery(".filter-article .btn").removeClass("active");
      } else {
        var index = filterCategories.indexOf(category);
        if (index !== -1) {
          filterCategories.splice(index, 1);
          jQuery(this).removeClass("active");
        } else {
          filterCategories.push(category);
          jQuery(this).addClass("active");
        }
      }

      filterAndUpdateUrl();
    }

    jQuery(".filter-article .btn").on("click", selectCategories);

    jQuery(".filter-article .btn").on("touchstart", selectCategories);

    function getUrlParameter(name) {
      name = name.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]");
      var regex = new RegExp("[\\?&]" + name + "=([^&#]*)");
      var results = regex.exec(location.search);
      return results === null
        ? ""
        : decodeURIComponent(results[1].replace(/\+/g, " "));
    }

    if (jQuery(".article-list .masonry")) {
      var filterValue = getUrlParameter("filter");
      if (filterValue) {
        filterCategories = filterValue.split(",");

        jQuery(".filter-article .btn").removeClass("active");
        filterCategories.forEach(function (category) {
          jQuery('.filter-article .btn[category="' + category + '"]').addClass(
            "active"
          );
        });

        filterAndUpdateUrl();
      }
    }
  }

  //menu mobile
  jQuery(".menu_icon").click(function () {
    jQuery(".mobileMenu").toggleClass("active");
  });
});
